<template>
<!-- 设备管理（模板） -->
    <div class="box-second">
        <p class="title-crumb">
            <el-breadcrumb separator-class="el-icon-arrow-right color3">
                <el-breadcrumb-item>设备管理</el-breadcrumb-item>
            </el-breadcrumb>
        </p>
        <div class="main">
            <div class="main-left">
                <p class="main-left-p">
                    <span>共有类型：{{folderList.length}}</span>
                    <el-button size="mini" type="text" @click="addEntFun" style="font-size:0.8vw;">添加类型</el-button>
                </p>
                <div class="main-left-list">
                    <ul>
                        <li v-for="(item,index) in folderList" :key="index" :class="{'curEnt':folderId==item.id}" @click="getEntId(item)">
                            <i class="el-icon-folder"></i>
                            <div class="unit-name color4">
                                <p :title="item.name" class="nowrap">{{item.name}}</p>
                            </div>
                            <div class="unit-ctl color4" style="width:40%;">
                                <el-button type="text" @click="editFolder(item)">编辑</el-button>
                                <el-button type="text" style="color:red;" @click="delFolder(item)">删除</el-button>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="main-table">
                <div class="table-head">
                    <div class="table-head-seach">
                    </div>
                    <div>
                        <el-button type="primary" plain style="margin-right:20px;" @click="moduel">模板管理</el-button>
                        <el-button type="primary" v-if="folderId!=''" plain @click="addDevice">添加设备</el-button>
                          <el-button  plain type="success" @click="exportFun" style="font-size:0.8vw;">导出</el-button>
                    </div>
                </div>
                <div class="table-box">
                    <el-table :data="tableDataEnd" height="100%" style="width: 100%" :header-cell-style="{background:'#F5F7F9',color:'#909399'}">
                        <template slot="empty">
                            <p>{{dataText}}</p>
                        </template>
                        <el-table-column label="序号" width="200">
                            <template slot-scope="scope">
                                <span>{{ scope.row.index }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="文件名称">
                            <template slot-scope="scope">
                                <span>{{ scope.row.name }}</span>
                            </template>
                        </el-table-column>
                        <!-- <el-table-column label="大小" width="200">
                            <template slot-scope="scope">
                            <span>{{ scope.row.filseCapacity }}B</span>
                            </template>
                        </el-table-column> -->
                        <el-table-column label="日期" >
                            <template slot-scope="scope">
                            <span>{{ scope.row.createDate }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作">
                            <template slot-scope="scope">
                                <el-button size="mini" style="margin-right:20px;" type="text" @click="toDetail(scope.$index, scope.row)">详情</el-button>
                                <el-button size="mini" style="margin-right:20px;" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
                                <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <!--  -->
                    <div class="el-end">
                        <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="currentPage"
                        :page-sizes="[5, 10, 20, 50]"
                        :page-size="pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="totalItems"
                        ></el-pagination>
                    </div>
                </div>
            </div>
        </div>
        <!-- 新增窗口 -->
        <el-dialog
        :title="entTitle"
        :visible.sync="entVisible"
        center
        :append-to-body="true"
        :lock-scroll="false"
        width="30%"
        >
            <el-form
                :model="addFolder"
                ref="addFolder"
                :rules="rules"
                label-width="140px"
                label-position="right"
                class="joinEnt"
            >
                <el-form-item label="设备类型：" prop="name">
                    <el-input v-model="addFolder.name" autocomplete="off" style="width:220px"></el-input>
                </el-form-item>
                <el-form-item label="选择模板：" prop="templateId">
                    <el-select v-model="addFolder.templateId" :disabled='addFolder.id!=""' filterable placeholder="请选择">
                        <el-option
                        v-for="item in templates"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="备注：">
                    <el-input type="textarea" v-model="addFolder.remark"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="entVisible = false">取 消</el-button>
                <el-button type="primary" @click="sumbitAddFolder('addFolder')">确 定</el-button>
            </div>
        </el-dialog>
        <!-- 设备弹出框 -->
        <el-dialog
            :title="macTit"
            :visible.sync="macVis"
            center
            :append-to-body="true"
            :lock-scroll="false"
            width="30%"
            style="height:100%;"
        >
            <el-form
                :model="macData"
                ref="macData"
                :rules="rulesMac"
                label-width="140px"
                label-position="right"
                class="joinEnt"
            >
                <el-form-item label="设备名称：" prop="name">
                    <el-input v-model="macData.name" autocomplete="off" style="width:220px"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="macVis = false">取 消</el-button>
                <el-button type="primary" @click="sumbitAddMac('macData')">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import util from '../../../untils/util'
import myHttp from '../../../untils/port'
import base from '../../../untils/base'
import vueQr from 'vue-qr'
export default {
    components: {
            vueQr
    },
    data(){
        return{
            // entName:'',//参建单位查询
            groupId:'',
            folderList:[],//参建单位list
            // entsTypes:[],//参建单位类型list
            entTitle:'',//参建单位弹出框名称
            entVisible:false,
            persons:[],//参建单位的管理人员
            addFolder:{
                name:'',
                templateId:'',
                id: '',
                projectId: '',
                createBy:'',
                remark:''
            },
            rules: {
                name: [
                    { required: true, message: '请填写设备类型', trigger: 'blur' }
                ],
                templateId:[
                    { required: true, message: '请选择模板', trigger: 'change' }
                ],
            },
            folderId:'',//当前展示文件夹id
            tableDataEnd:[],//班组列表
            diaTitle:'添加文件夹',//班组添加名称
            dataText: '数据加载中...',
            // teamName:'',//班组名称
            // uploadUrl:base.url+"/upload/uploadPhoto",//上传地址
            // uploadHead:{  //上传接口header
            //     accessToken:this.$store.state.token
            // },
            templates:[],//
            //二维码
            // codeVis:false,
            // codeUrl:'',
            // codeTit:'',
            macData:{    //设备数据
                facilityId:'',
                name:'',
                createBy:'',
                templateId:'',
                id:''
            },
            macTit:'',//设备弹出框title
            macVis:false,
            rulesMac:{
                name: [
                    { required: true, message: '请填写设备名称', trigger: 'blur' }
                ],
            },
            currentPage: 1,
            pageSize: 10,
            totalItems: 0,

        }
    },
    mounted(){
        var port = util.session.get('roleId')
        this.groupId = util.session.get('groupId')
        this.getFolder()
        // this.getPerson()
        this.getTempleteList()
    },
    methods:{

        handleSizeChange(val) {
            this.pageSize = val
            this.handleCurrentChange(this.currentPage)
        },
        handleCurrentChange(val) {
            this.currentPage = val
            this.currentChangePage()
        },
        //监控当前页码
        currentChangePage(list) {
            this.getData()
        },
        //g获取模板列表
        getTempleteList(){
            var that = this
            myHttp.getProFacilityTemplateList({
                projectId:this.groupId,
                pageNum:'1',
                pageSize:1000
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var list = resp.data.data.proFacilityTemplate.list||[]
                    that.templates = list
                }else{
                    that.templates = []
                }
            })
        },
        //获取设备类型
        getFolder(){
            var that = this
            myHttp.getProFacility({
                projectId:this.groupId,
            }).then(function(resp){
                if (resp.data.code == '200'){
                    var list = resp.data.data.proFacility || []
                    that.folderList = list
                    if(list.length>0){
                        that.folderId = list.length>0?list[0].id:''
                        that.getData()
                    }else{
                        that.currentPage = 1
                        that.totalItems = 0
                        that.dataText = '暂无数据'
                    }
                }
            })
        },
        //添加参建单位
        addEntFun(){
            this.entVisible = true
            this.addFolder.name = ''
            this.addFolder.id = ''
            this.addFolder.remark = ''
            this.addFolder.templateId = ''
            this.entTitle = '添加设备种类'
            
        },
        
        //添加或者修改文件夹
        sumbitAddFolder(formName){
            var that = this
            this.addFolder.createBy = util.session.get('user').id
            this.addFolder.projectId = this.groupId
            this.$refs[formName].validate(valid => {
                if (valid) {
                if (this.addFolder.id == '') {
                    myHttp.createProFacility(this.addFolder).then(function(resp) {
                    if (resp.data.code == '200') {
                        that.$message.success('添加成功')
                        that.entVisible = false
                        that.getFolder()
                    } else {
                        that.$message.error(resp.data.msg)
                    }
                    })
                } else {
                    myHttp.updateFiles(this.addFolder).then(function(resp) {
                    if (resp.data.code == '200') {
                        that.$message.success('修改成功')
                        that.entVisible = false
                        that.getFolder()
                    } else {
                        that.$message.error(resp.data.msg)
                    }
                    })
                }
                } else {
                  return false
                }
            })
        },
        //选择展示的文件夹
        getEntId(row){
            this.folderId = row.id
            this.getData()
        },

        /***
         * 获取文件
         */
        getData(){
            var that = this
            myHttp.proTemplateDataList({
                facilityId:this.folderId,
                templateId:this.getTempByFid(this.folderId),
                pageNum:this.currentPage,
                pageSize:this.pageSize
            }).then(function(resp){
                console.log(resp)
                if (resp.data.code == '200') {
                    var list = resp.data.data.proTemplateDataPage.list || []
                    for(var i=0;i<list.length;i++){
                        // list[i].fileFormat = list[i].filesName && list[i].filesName!=''?that.getImg(list[i].filesName):'0'
                        list[i].index = (that.currentPage - 1) * that.pageSize + (i + 1)
                    }
                    that.tableDataEnd = list
                    that.totalItems = resp.data.data.proTemplateDataPage.total||0
                    if (that.totalItems == 0) {
                        that.dataText = '暂无数据'
                    }
                } else {
                    that.$message.error(resp.data.msg)
                    that.dataText = '暂无数据'
                }
            })
        },
        //获取数据模板
        getTempByFid(id){
            var list = this.folderList
            var result = ''
            for(var i=0;i<list.length;i++){
                if(id==list[i].id){
                    result = list[i].templateId
                }
            }
            return result
        },
        /**
         * 根据名称查询班组
         */
        doFilter(){
            this.getTeam()
        },
        /**
         * 添加设备
         */
        addDevice(){
            this.macVis = true
            this.macTit = '添加设备'
            this.macData.name = ''
        },
        /**
         * 提交设备
         */
        sumbitAddMac(formName){
            var that = this
            this.macData.createBy = util.session.get('user').id
            this.macData.projectId = this.groupId
            this.macData.facilityId = this.folderId
            this.macData.templateId = this.getTempByFid(this.folderId)
            this.$refs[formName].validate(valid => {
                if (valid) {
                if (this.macData.id == '') {
                    myHttp.createProTemplateData(this.macData).then(function(resp) {
                    if (resp.data.code == '200') {
                        that.$message.success('添加成功')
                        that.macVis = false
                        that.getData()
                    } else {
                        that.$message.error(resp.data.msg)
                    }
                    })
                } else {
                    myHttp.updateProTemplateData(this.macData).then(function(resp) {
                    if (resp.data.code == '200') {
                        that.$message.success('修改成功')
                        that.macVis = false
                        that.getData()
                    } else {
                        that.$message.error(resp.data.msg)
                    }
                    })
                }
                } else {
                  return false
                }
            })
        },
        // addTeam(){
        //     this.addFormVisible = true
        //     // this.teamPersons = []
        //     this.getPerson()
        //     this.addForm = {
        //         id: '',
        //         name: '',
        //         teamsType: '1',
        //         creditCode: '',
        //         remarks: '',
        //         projectEntId: this.joinEntId,
        //         teamManager: '',
        //         managerTel: ''
        //     }
        //     this.diaTitle = '添加班组'
        // },
        //修改班组
        handleEdit(index, row) {
            this.macVis = true
            this.macData.name = row.name
            this.macData.id = row.id
            this.macTit = '设备修改'
        },
        //展示
        // showFile(row){
        //     var that = this
        //     window.open(base.fileView+'/onlinePreview?url='+encodeURIComponent(base.httpCtx+row.filesAddress),"_blank");
        // },
        //下载
        // handleDown(index,row){
        //     window.open(base.httpCtx+row.filesAddress)
        // },
        // 删除设备
        handleDelete(index, row) {
            var that = this
            this.$confirm('此操作将永久删除该设备, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                myHttp.deleteProTemplateData({
                    id: row.id,
                    updateBy:util.session.get('user').id
                }).then(function(resp) {
                    if (resp.data.code == '200') {
                        that.$message({
                        type: 'success',
                        message: '删除成功!'
                        })
                        that.getData()
                    } else {
                        that.$message.error(resp.data.msg)
                    }
                })
            }).catch(err => {})
        },
        //上传成功
        // fileSuccess(res,file,opt){
        //     if(res.code==200){
        //         var obj = {
        //             filesType:'2',
        //             type:'1',
        //             filesName:file.name,
        //             filesAddress:res.data.saveUrls,
        //             filseCapacity:file.size,
        //             groupId:this.groupId,
        //             userType:util.session.get('roleId'),
        //             parentId:this.folderId,
        //             createBy:util.session.get('user').id
        //         }
        //         var that = this
        //         myHttp.addFolderFiles(obj).then(function(resp){
        //             if(resp.data.code=='200'){
        //                 that.$message.success('添加成功')
        //                 that.getData()
        //             }else{
        //                 that.$message.error(resp.data.msg)
        //             }
        //         })
        //     }else{
        //         this.$message.error(res.msg);
        //     }
            
        // },
        //编辑设备类型
        editFolder(obj){
            this.entVisible = true
            this.addFolder.name = obj.name
            this.addFolder.id = obj.id
            this.addFolder.templateId = obj.templateId
            this.addFolder.remark = obj.remark
            this.entTitle = '修改设备类型'

        },
        //删除文件夹
        delFolder(obj){
            var that = this
            this.$confirm('此操作将永久删除该设备类型及其中的设备, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                myHttp.deleteProFacility({
                    id: obj.id,
                    updateBy:util.session.get('user').id
                }).then(function(resp) {
                    if (resp.data.code == '200') {
                        that.$message.success('删除成功')
                        that.getFolder()
                    } else {
                        that.$message.error(resp.data.msg)
                    }
                })
            })
        },

        //详情
        toDetail(index,row){
            this.$router.push({path:'/equipMgeDetail/'+row.id})
        },
        moduel(){
             this.$router.push({path:'/addmould'})
        },
           //导出
        exportFun(){
            var token = this.$store.state.token
            var templateId =this.getTempByFid(this.folderId)
            var facilityId = this.folderId
            // console.log(projectType)
            window.open(
                myHttp.exportProTemplateExcel +
                '?templateId=' +
                templateId +
                '&facilityId=' +
                facilityId +
                '&accessToken=' +
                token
            )

        },
        
        //展示二维码
        // erCode(index,row){
        //     this.codeVis = true
        //     this.codeUrl = base.httpCtx+row.filesAddress
        //     this.codeTit = row.filesName
        // },
    }

}
</script>
<style scoped>
    
    .main-left{
        width: 15vw;
        height: 100%;
        position: relative;
        /* overflow: auto; */
        background: #fff;
        border-radius: 0.5vh;
    }
    .main-left-search{
        width: 100%;
        height: 10%;
        position: relative;
        display: flex;
        align-content: center;
        align-items: center;
        padding: 1vh;
    }
    .main-left-p{
        width: 100%;
        height: 7%;
        position: relative;
        display: flex;
        align-content: center;
        align-items: center;
        justify-content:space-between;
        padding: 0 1vh;
    }
    .main-left-list{
        width: 100%;
        height: 85%;
        position: relative;
        overflow: auto;
    }
    .main-left-list li{
        width: 100%;
        height: 5vh;
        position: relative;
        padding:1vh 2vh;
        display: flex;
        align-content: center;
        align-items: center;
        border-bottom: 1px solid #eee;
        cursor: pointer;
    }
    .main-left-list li:hover{
        background: #eee;
    }
    .curEnt{
        background: #E7F1FB;
    }
    .curEnt i,.curEnt p{
        color: #5A87F9;
    }
    /* .unit-type{
        width: 20%;
        height: 100%;
        position: relative;
        display: flex;
        justify-content: center;
        justify-items: center;
        align-items: center;
        align-content: center;
        border: 1px solid #0365F2;
        padding: 1.5%;
    } */
    .unit-name{
        width: 60%;
        height: 100%;
        position: relative;
        display: flex;
        align-items: center;
        align-content: center;
        padding-left: 1vh;
        flex-wrap: wrap;
    }
    .unit-name p{
        width: 100%;
        text-align: left;
    }
    .main-table{
        width: calc( 100% - 15vw );
        height: 100%;
        position: relative;
        padding-left: 1vw;
        display: flex;
        flex-wrap: wrap;
    }
    .table-head{
        width: 100%;
        height: 6vh;
        position: relative;
        background: #fff;
        border-top-left-radius: 0.5vh;
        border-top-right-radius: 0.5vh;
        display: flex;
        align-content: center;
        align-items: center;
        padding: 2vh;
        justify-content: space-between;
    }
    .table-head-seach{
        width: 20%;
        height: 100%;
        position: relative;
    }
    .table-box{
        width: 100%;
        height: calc( 100% - 6vh );
        position: relative;
        background: #fff;
        border-bottom-left-radius: 0.5vh;
        border-bottom-right-radius: 0.5vh;
    }
    .box-ent{
        width: 100%;
        height: 10vh;
        position: relative;
        margin-bottom: 1vh;
        background: #fff;
        border-radius: 5px;
        display: flex;
        /* flex-wrap: wrap; */
    }
    .box-ent-l{
        width: 80%;
        height: 100%;
        position: relative;
        display: flex;
        flex-wrap: wrap;
        padding: 2vh;
        align-content: center;
        align-items: center;
    }
    .box-ent-l p{
        width: 33%;
        height: 3vh;
        position: relative;
        text-align: left;
        padding-right: 1vh;
    }
    .box-ent-r{
        width: 20%;
        height: 100%;
        display: flex;
        align-content: center;
        align-items: center;
    }
    
    .erCode{
        width: 100%;
        height: 100%;
        position: relative;
        display: flex;
        justify-content: center;
        justify-items: center;
        align-content: center;
        align-items: center;
        flex-wrap: wrap;
    }
</style>
<style>
@import '../../../assets/css/common.css';
</style>